export function toFiltersUrl(queryString: string) {
  return `/nd/search/?${queryString}&from_map=true`;
}
